// No additional types needed

/** Launch animated fish tokens flying from start (e.g., button) to token display.
 *  Uses simple DOM <img> elements like other screen-space effects (e.g., hammer, coin).
 */
export function launchFishTokenEffect(
  startRect: DOMRect,
  tokensAwarded: number,
) {
  const targetRect: DOMRect | undefined = (window as any)._tokenTargetRect;
  if (!targetRect) return;

  // Spawn roughly 1 fish per 5 tokens, at least 1.
  const numFish = Math.max(1, Math.floor(tokensAwarded / 5));

  for (let i = 0; i < numFish; i++) {
    const img = document.createElement("img");
    img.src = "/assets/misc/fish.png"; // public path
    img.style.position = "fixed";
    img.style.left = `${startRect.left + startRect.width / 2}px`;
    img.style.top = `${startRect.top + startRect.height / 2}px`;
    img.style.width = "36px";
    img.style.height = "36px";
    img.style.pointerEvents = "none";
    img.style.zIndex = "2000";
    document.body.appendChild(img);

    const dx =
      targetRect.left +
      targetRect.width / 2 -
      (startRect.left + startRect.width / 2);
    const dy =
      targetRect.top +
      targetRect.height / 2 -
      (startRect.top + startRect.height / 2);

    const midX = dx * 0.5;
    // create upward arc: random lift between 80-140px
    const lift = 80 + Math.random() * 60;

    const anim = img.animate(
      [
        { transform: "translate(0,0) scale(1.2) rotate(0deg)", opacity: 1 },
        {
          transform: `translate(${midX}px, ${dy * 0.5 - lift}px) scale(1.6) rotate(${Math.random() > 0.5 ? 20 : -20}deg)`,
          opacity: 1,
        },
        {
          transform: `translate(${dx}px, ${dy}px) scale(0.8) rotate(0deg)`,
          opacity: 0.05,
        },
      ],
      {
        duration: 900,
        delay: i * 90,
        easing: "ease-in-out",
        fill: "forwards",
      },
    );

    anim.onfinish = () => {
      img.remove();
      if (navigator.vibrate) navigator.vibrate(15);
    };
  }
}
